import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  getGeneralService
} from 'services/systems';
import {
  GeneralDataTypes
} from 'services/systems/types';

interface SystemState {
  system?: GeneralDataTypes;
  language?: string;
  enableWS?: string;
}

const initialState: SystemState = {
  system: undefined,
  enableWS: '',
};

export const getSystemAction = createAsyncThunk<GeneralDataTypes>(
  'systemReducer/getSystem',
  async (_, { rejectWithValue }) => {
    try {
      return await getGeneralService();
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const systemSlice = createSlice({
  name: 'systemReducer',
  initialState,
  reducers: {
    setLanguage($state, action: PayloadAction<string>) {
      $state.language = action.payload;
    },
    setEnableWS: ($state, action: PayloadAction<string>) => {
      $state.enableWS = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(getSystemAction.fulfilled, ($state, action) => {
      $state.system = action.payload;
    });
  },
});

export const {
  setLanguage,
  setEnableWS
} = systemSlice.actions;

export default systemSlice.reducer;
